export const MatchLineupHeaderSkeleton = () => {
	return (
		<div className="animate-pulse mt-6">
			{/* Main Content Container */}
			<div className="flex flex-col sm:flex-row sm:justify-between">
				{/* Left side - Score Info Card */}
				<div className="sm:max-w-[380px] w-full">
					<div className="mb-5 sm:mb-0">
						{/* Desktop Score Card */}
						<div className="hidden sm:block">
							<div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
								{/* Date and Status Row */}
								<div className="flex items-center justify-between mb-4">
									<div className="h-5 w-36 rounded bg-gray-200" />
									<div className="h-6 w-24 rounded-full bg-gray-200" />
								</div>
								{/* Location */}
								<div className="mb-4 flex items-center gap-2">
									<div className="size-4 rounded-full bg-gray-200" />
									<div className="h-5 w-40 rounded bg-gray-200" />
								</div>

								{/* Teams and Scores */}
								<div className="space-y-3">
									<div className="flex items-center justify-between">
										<div className="h-7 w-48 rounded bg-gray-200" />
										<div className="h-8 w-8 rounded bg-gray-200" />
									</div>
									<div className="flex items-center justify-between">
										<div className="h-7 w-48 rounded bg-gray-200" />
										<div className="h-8 w-8 rounded bg-gray-200" />
									</div>
								</div>
							</div>
						</div>

						{/* Mobile Score Card */}
						<div className="sm:hidden">
							<div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
								{/* Date and Status */}
								<div className="flex items-center justify-between mb-3">
									<div className="h-4 w-28 rounded bg-gray-200" />
									<div className="h-5 w-20 rounded-full bg-gray-200" />
								</div>

								{/* Teams and Scores */}
								<div className="space-y-2">
									<div className="flex items-center justify-between">
										<div className="h-6 w-36 rounded bg-gray-200" />
										<div className="h-7 w-10 rounded bg-gray-200" />
									</div>
									<div className="flex items-center justify-between">
										<div className="h-6 w-36 rounded bg-gray-200" />
										<div className="h-7 w-10 rounded bg-gray-200" />
									</div>
								</div>

								{/* Location */}
								<div className="mt-3 flex items-center gap-2">
									<div className="size-4 rounded-full bg-gray-200" />
									<div className="h-4 w-32 rounded bg-gray-200" />
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Right side - Action Buttons */}
				<div className="min-w-40">
					<div className="flex flex-col gap-3">
						{/* Print Button */}
						<div className="h-10 w-full rounded-lg border border-gray-200 bg-gray-200" />
						{/* Edit Status Button */}
						<div className="h-10 w-full rounded-md border border-gray-200 bg-gray-200" />
						{/* Substitute Button */}
						<div className="h-10 w-full rounded-md border border-gray-200 bg-gray-200" />
					</div>
				</div>
			</div>
		</div>
	);
};
